import type { CSSProperties } from "react"

import isNumber from "lodash-es/isNumber"

import type { TAccordionProps } from "./accordion.types"

export default {
    getHeaderBorderRadiusStyles({
        config,
        isExpanded
    }: {
        config: Pick<TAccordionProps, "headerBorderRadius">["headerBorderRadius"]
        isExpanded: boolean
    }): CSSProperties {
        return {
            borderRadius: isNumber(config)
                ? `${config}px`
                : isExpanded
                  ? `${config.expanded.tl}px ${config.expanded.tr}px ${config.expanded.br}px ${config.expanded.bl}px`
                  : `${config.collapsed.tl}px ${config.collapsed.tr}px ${config.collapsed.br}px ${config.collapsed.bl}px`
        }
    }
}
